export const blockIconsDeviceSportsScore = (
	<span className='material-symbols-outlined'>sports_score</span>
);
